/* getThemeColor usage
   ========================

getThemeColor can be called with a string as a default argument, and it will
     return a function to include in the style-component css.
   Otherwise, it will evaluate the props passed to it with a default
     argument of "inherit".

   Example 1 (default to inherit)
   `color: ${getThemeColor}`
   Example 2 (default to red)
   `color: ${getThemeColor(red)}`
   */
import { css } from "styled-components";

const themeColorHelper = defaultColor => ({ theme, color = defaultColor }) => {
  return theme.colors[color];
};

export const getThemeColor = arg => {
  if (typeof arg === "string") {
    return themeColorHelper(arg);
  }
  return themeColorHelper("inherit")(arg);
};

export const getFontFamily = ({ theme, serif = false }) => {
  return `font-family: ${serif ? "Palatino" : "Avenir Next"}`;
};

export const r = (attr, defaultValue, mobileValue) => props => css`
    ${attr}: ${defaultValue};
    ${props.theme.media.mobile`
      ${attr}: ${mobileValue};
    `};`;

export const slugify = (title = "") => title.toLowerCase().split(" ").join("-");



// WEBPACK FOOTER //
// ./src/utils.js